import React from 'react'
import downloadIcon from '../../../img/icons/download.png'
import defaultThumb from '../../../img/icons/document.png'

const Download = ({attrs, images}) => {
	const image = attrs && attrs.mediaId && images && images.find(({wordpress_id}) => wordpress_id === attrs.mediaId)
	const imageSharpSizes = image && image.localFile && image.localFile.childImageSharp && image.localFile.childImageSharp.sizes
	const imageBackground = {backgroundImage: `url(${imageSharpSizes ? imageSharpSizes.src : defaultThumb})`}
	const imageClassName = `block-download-thumb${imageSharpSizes ? ' block-download-thumb-default' : ''}`

	return(
		<section 
			className="block-download"
			role="region"
			aria-describedby="download-description"
			aria-label="Zone de téléchargement"
		>
			<a 
				href={attrs?.fileUrl ? attrs.fileUrl : "#"} 
				target="_blank" 
				rel="noopener noreferrer" 
				title="Télécharger le document (s'ouvre dans un nouvel onglet)"
				aria-label="Télécharger le document (s'ouvre dans un nouvel onglet)"
			>
				<div 
					className={imageClassName} 
					style={imageBackground}
					data-testid="download-thumb"
					role="img"
					aria-label="Aperçu du document"
				></div>
				<div 
					id="download-description"
					className="block-download-text" 
					dangerouslySetInnerHTML={{__html: attrs?.downloadContent || ''}}
				></div>
				<div className="block-download-button">
					<img 
						className="block-download-button-img" 
						src={downloadIcon} 
						alt="Icône de téléchargement"
					/>
				</div>
			</a>
		</section>
	)
}

export default Download
